import { Box, TextField, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import React, { useState } from 'react';
import axiosService from 'utils/axios';
import { Destination } from '../../../types/entities/destination_type';
import ModalPopup from '../../../components/Modal/ModalPopup';

interface Props {
  destination?: Destination;
  destinationName?: string;
  onSave: (destination: Destination) => void;
  modalTitle: string;
  isModalOpen: boolean;
  setModalOpen: (open: boolean) => void;
}

interface DestinationCreateUpdateError {
  error: string;
}

export default function AddOrEditDestination(props: Props) {
  const { destination, destinationName = '', onSave, modalTitle, isModalOpen, setModalOpen } = props;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<DestinationCreateUpdateError | null>();

  const [nameInput, setNameInput] = useState(destination?.name || destinationName);
  const [notesInput, setNotesInput] = useState(destination?.notes || '');

  const handleSubmit = () => {
    setLoading(true);
    const data = {
      // eslint-disable-next-line camelcase
      name: nameInput,
      notes: notesInput,
    };
    if (destination) {
      // Update existing destination
      axiosService
        .patch(`/entities/destination/${destination.id}/`, data)
        .then(destinationData => {
          setLoading(false);
          setError(null);
          onSave(destinationData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    } else {
      // Create new destination
      axiosService
        .post('/entities/destination/', data)
        .then(destinationData => {
          setLoading(false);
          setError(null);
          onSave(destinationData.data);
        })
        .catch(err => {
          setLoading(false);
          setError(err.response.data || {});
        });
    }
  };

  return (
    <ModalPopup
      title={modalTitle}
      open={isModalOpen}
      onClose={() => setModalOpen(false)}
      actionButtons={
        <LoadingButton
          loading={loading}
          onClick={handleSubmit}
          type="submit"
          fullWidth
          variant="contained"
          disabled={!nameInput}
        >
          {destination ? 'Edit destination' : 'Create destination'}
        </LoadingButton>
      }
    >
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <Box sx={{ width: '100%', mt: 1 }}>
          {error ? <Typography>{error.error}</Typography> : null}
          <TextField
            required
            autoFocus
            fullWidth
            margin="normal"
            id="name"
            label="Name"
            value={nameInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNameInput(event.target.value);
            }}
          />
          <TextField
            fullWidth
            minRows={5}
            multiline
            margin="normal"
            id="notes"
            label="Notes"
            value={notesInput}
            onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
              setNotesInput(event.target.value);
            }}
          />
        </Box>
      </Box>
    </ModalPopup>
  );
}
